import AboutUsHero from '@/components/AboutUsHero';
import AboutUsSection from '@/components/AboutUsSection';
import CreateAvatar from '@/components/CreateAvatar';
import Footer from '@/components/Footer';
import AboutOurBooks from '@/components/AboutOurBooks';
import FeaturedIn from '@/components/shared/FeaturedIn';
import Header from '@/components/shared/Header';
import Head from 'next/head';
import React, { useEffect, useState } from 'react';
import {
  fetchProductList,
  initializeCart,
  loadPreviewRelatedContent,
  populateCharacterConfigured,
  populateCurrentStep,
  populateCurrentStepPah
} from '@/store/initializeState';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import BehindTheMagic from '@/components/BehindTheMagic';

const AboutUs: React.FC = () => {
  const [redirect, setRedirect] = useState<string>('');

  const dispatch = useDispatch();

  const { productList, configSetupBuildKey, productCart } = useSelector(
    (state: RootStateOrAny) => state
  );

  const [showCharacterBuilderModal, setShowCharacterBuilderModal] =
    useState<boolean>(false);

  useEffect(() => {
    loadPreviewRelatedContent(configSetupBuildKey, dispatch);
    fetchProductList(productList, dispatch);
    initializeCart(productCart, dispatch);
    populateCharacterConfigured(dispatch);
    populateCurrentStep(dispatch);
    populateCurrentStepPah(dispatch);
  }, []);

  return (
    <div>
      <Head>
        <title>Keepsake Tales | About us</title>
        <meta
          name="description"
          content="At Keepsake Tales, we exist to help every child understand that they are one of a kind. We make each child the main character of their own story so that every child will know how much they matter."
        />
        <meta
          property="og:title"
          content="Your Child is a CHAMPION - Show Them | Keepsake Tales | About us"
        />
        <meta
          property="og:description"
          content="At Keepsake Tales, we exist to help every child understand that they are one of a kind. We make each child the main character of their own story so that every child will know how much they matter."
        />
        <meta property="og:type" content="books.book" />
        <meta
          property="og:url"
          content="https://www.keepsaketales.com/about-us"
        />
        <meta
          property="og:image"
          content="https://www.keepsaketales.com/keepsake-tales.png"
        />
        <meta
          property="og:image:secure_url"
          content="https://www.keepsaketales.com/keepsake-tales.png"
        />
        <link rel="icon" href="/favicon.ico" />
        <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1"
        ></meta>
      </Head>
      <Header
        currentPage="about-us"
        setShowCharacterBuilderModal={setShowCharacterBuilderModal}
        setRedirect={setRedirect}
      />
      <main>
        <AboutUsHero />
        <AboutUsSection />
        <BehindTheMagic className="bg-lightBlue" />
        <AboutOurBooks />
        <FeaturedIn />
        <Footer />
        <CreateAvatar
          showCharacterBuilderModal={showCharacterBuilderModal}
          setShowCharacterBuilderModal={setShowCharacterBuilderModal}
          redirect={redirect}
        />
      </main>
    </div>
  );
};

export default AboutUs;
